import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setConfirmation, setMarket, setRunner, setIsBack, setPrice, setPriceActual, setStake, setDelay, setShowBetPlacingPopover, setBetPlacingPopoverStage } from '../../store/betPlacing/betPlacing.slice'
import { requestSetOrder } from '../../store/betPlacing/betPlacing.thunks'
import { setInfoDetailed, setThisEvent } from '../../store/openBetsList/openBetsList.slice'
import { setIsOpen } from '../../store/editStakesPopUp/editStakesPopUp.slice'
import { setLoginNew } from '../../store/LoginNew/loginNew.slice'

export const connectBetSlipDesktop = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      betPlacing: state.betPlacing,
      presetStakeSettings: state.user.settings.presetStakeSettings,
      oneClick: state.user.settings.oneClickSettings.active,
      openBets: state.openBets,
      auth: state.auth
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      requestSetOrder,
      setConfirmation,
      setMarket,
      setRunner,
      setIsBack,
      setPrice,
      setPriceActual,
      setDelay,
      setStake,
      setShowBetPlacingPopover,
      setBetPlacingPopoverStage,
      setInfoDetailed,
      setThisEvent,
      setIsOpen,
      setLoginNew,
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
